import { Controller } from "@hotwired/stimulus";

// Full-screen panel for mobile, replaces the side drawer.
// Listens for "mobile-panel:open" on window so trigger buttons anywhere can open it.
export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this._boundOpen = () => this.open();
    window.addEventListener("mobile-panel:open", this._boundOpen);
  }

  disconnect() {
    window.removeEventListener("mobile-panel:open", this._boundOpen);
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
  }

  closeOnSuccess(event) {
    if (event.detail.success) {
      this.close();
    }
  }
}
